import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { chatAPI } from '../../services/api';

export const fetchChatRooms = createAsyncThunk(
  'chat/fetchRooms',
  async () => {
    const response = await chatAPI.getRooms();
    return response.data;
  }
);

export const fetchMessages = createAsyncThunk(
  'chat/fetchMessages',
  async ({ roomId, params = {} }) => {
    const response = await chatAPI.getMessages(roomId, params);
    return { roomId, messages: response.data };
  }
);

export const sendMessage = createAsyncThunk(
  'chat/sendMessage',
  async ({ roomId, data }) => {
    const response = await chatAPI.sendMessage(roomId, data);
    return { roomId, message: response.data };
  }
);

export const startPrivateChat = createAsyncThunk(
  'chat/startPrivate',
  async (userId) => {
    const response = await chatAPI.startPrivateChat({ user_id: userId });
    return response.data;
  }
);

export const createChatRoom = createAsyncThunk(
  'chat/createRoom',
  async (data) => {
    const response = await chatAPI.createRoom(data);
    return response.data;
  }
);

const chatSlice = createSlice({
  name: 'chat',
  initialState: {
    rooms: [],
    currentRoom: null,
    messages: {},
    loading: false,
    error: null,
  },
  reducers: {
    setCurrentRoom: (state, action) => {
      state.currentRoom = action.payload;
    },
    addMessage: (state, action) => {
      const { roomId, message } = action.payload;
      if (!state.messages[roomId]) {
        state.messages[roomId] = [];
      }
      state.messages[roomId].push(message);
    },
    clearCurrentRoom: (state) => {
      state.currentRoom = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchChatRooms.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchChatRooms.fulfilled, (state, action) => {
        state.loading = false;
        state.rooms = action.payload.results || action.payload;
      })
      .addCase(fetchChatRooms.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchMessages.fulfilled, (state, action) => {
        const { roomId, messages } = action.payload;
        state.messages[roomId] = messages.results || messages;
      })
      .addCase(sendMessage.fulfilled, (state, action) => {
        const { roomId, message } = action.payload;
        if (!state.messages[roomId]) {
          state.messages[roomId] = [];
        }
        state.messages[roomId].push(message);
      })
      .addCase(startPrivateChat.fulfilled, (state, action) => {
        const exists = state.rooms.find(r => r.id === action.payload.id);
        if (!exists) {
          state.rooms.unshift(action.payload);
        }
        state.currentRoom = action.payload;
      })
      .addCase(createChatRoom.fulfilled, (state, action) => {
        state.rooms.unshift(action.payload);
        state.currentRoom = action.payload;
      });
  },
});

export const { setCurrentRoom, addMessage, clearCurrentRoom } = chatSlice.actions;
export default chatSlice.reducer;
